import React from "react";
import "./SimilarJobsItem.scss";
import Card from "react-bootstrap/Card";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import StringUtils from "../../../utils/StringUtils.js";
import PlaceIcon from "@mui/icons-material/Place";
import BusinessIcon from "@mui/icons-material/Business";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import * as ROUTES from "../../../constants/routes.js";
import RouterUtils from "../../../utils/RouterUtils.js";
import ActionLink from "../../common/widgets/ActionLink.js";
import useTranslationLanding from "../../landing/useTranslationLanding.js";
import TypeUtils from "../../../utils/TypeUtils.js";
import useLanguages from "../../infra-no-ui/translation/useLanguages.js";
import useReferrer from "../../infra-no-ui/navigation/useReferrer.js";

export default function JobSearchItemLanding(props) {
  const {redirectTo} = useReferrer();

  const onClickViewAll = () => {
    redirectTo(
      RouterUtils.injectParamsInRoute(ROUTES.RECRUITER_JOB, {
        jobId: job._id,
      })
    );
  };

  const { t, loading: tLoading } = useTranslationLanding();
  useShowLoader(tLoading, "JobSearchItemLanding");

  const {getCurrentLanguageCode} = useLanguages();

  const { item: job } = props;

  const addressLine = TypeUtils.arrayRemoveNullOrEmpty([job.city, job.state, job.country])
    .join(", ");

  // RENDER

  return (
    <Card className="SimilarJobsItem" id={job._id}>
      <Card.Body className="job-search-card">
        <Row className="job-search-row-container">
          <Col className="jobInformation">
            <Row>
              <Col>
                <ActionLink onClick={onClickViewAll} className="job-link">
                  {job.title}
                </ActionLink>
              </Col>
            </Row>
            <Row className="logo-row">
              <Col className="icon-col-container">
                <Row>
                  <Col className="icon-col">
                    <BusinessIcon />
                  </Col>
                  <Col>{job.organization && job.organization.company}</Col>
                </Row>
              </Col>
              {!StringUtils.isNullOrEmpty(addressLine) && (
                <>
                  <Col className="icon-col-container">
                    <Row>
                      <Col className="icon-col">
                        <PlaceIcon />
                      </Col>
                      <Col>{addressLine}</Col>
                    </Row>
                  </Col>
                </>
              )}
            </Row>
          </Col>
          <Col className="last-col">
            <Row>
              <Col className="commission-title-col">
                {t("landing:landing_job_commission_title")}
              </Col>
            </Row>
            <Row>
              <Col className="commission-col">
                {StringUtils.formatMoney(job.commission, getCurrentLanguageCode())}
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
